import React, { forwardRef } from "react";

import cn from "classnames";

import { Input } from "./components/Input/InputTextInput";
import { INPUT_TEXT_DISPLAY_NAME } from "./utils/core";
import { CoreInputText } from "../../helpers/common/CoreInputText/CoreInputText";

import type { InputTextPropsWithTextMask } from "./types";

import classes from "./InputText.styl";

/**
 * Базовый компонент, который позволяет пользователю вводить текстовую информацию с клавиатуры
 *
 * <a href="https://www.figma.com/design/qdqGHY32KlkrIwX3eppFUx/%E2%9C%8F%EF%B8%8F-Inputs-%26-Search?m=auto&node-id=2027-52986">Спека</a>
 */
export const InputText = forwardRef<
    HTMLInputElement,
    InputTextPropsWithTextMask
>(
    (
        {
            children,
            size,
            "data-tsid": tsid,
            prefix = INPUT_TEXT_DISPLAY_NAME,
            ...props
        },
        ref,
    ) => {
        const wrapperClasses = (() => {
            const result = {} as cn.Mapping;
            if (size) {
                result[classes[`__size-${size}`]] = true;
            }

            return cn(classes.input, result);
        })();

        return (
            <CoreInputText
                {...props}
                as={Input}
                size={size}
                inputContainerClassName={wrapperClasses}
                prefix={prefix}
                data-tsid={tsid}
                data-uikit={prefix}
                ref={ref}
            >
                {children}
            </CoreInputText>
        );
    },
);

InputText.displayName = INPUT_TEXT_DISPLAY_NAME;

export default InputText;
